<template>
<div>
  <Layout>
  <b-container fluid>
    <b-card class="d-flex">
    <header style="background-color: #4d63cf;
          padding-top: 30px;
          padding-bottom: 30px;
          border-radius: 15px">
      <h2
          class="text-white"
          style="text-align: center"
      >{{$t("message.Choose_lang")}}</h2>
    </header>
      <b-row>
        <b-col md="6">
          <b-row class="mt-5">
            <b-col v-for="(l, lIndex) in languages" :key="lIndex" md="6" cols="6" xs="6">
              <b-button
                  :variant="l.prefix === testLang  ? 'primary text-white' : 'outline-primary'"
                  type="button"
                  class="btn btn-outline-primary"
                  @click="getLangAndGo(l.prefix)"
              >{{l.label}}</b-button>
            </b-col>
          </b-row>
          <div class="w-100 mt-5 d-flex justify-content-center">
            <b-button
                class="w-50 mt-5"
                variant="primary"
                @click="handlePush"
            >{{$t('message.Begin_test')}}</b-button>
          </div>
        </b-col>
        <b-col md="6">
            <img
                src="https://thumbs.dreamstime.com/b/concept-online-exam-testing-questionnaire-form-education-survey-internet-quiz-isometric-vector-illustration-163649153.jpg">
        </b-col>
      </b-row>
    </b-card>
  </b-container>
  </Layout>
</div>
</template>

<script>
import Layout from "../../../../layouts/main";
export default {
  name: "TestLanguage",
  components:{
    Layout
  },
  data() {
    return {
      testLang: '',
      languages: [
        {prefix:'uz',label: "O'zbekcha"},
        {prefix:'ru',label: "Русский"},
        {prefix:'kr',label: "Karakalpak"},
        {prefix:'en',label: "English"},
      ],
    }
  },
  methods:{
    handlePush(){
      this.$router.push({ name:'test', params: {lang: this.testLang,testId:this.$route.params.testId}})
    },
    getLangAndGo(lang) {
      this.testLang = lang;
    }
  }
}
</script>

<style scoped>
h2 {
  text-align: center;
  color: #4d63cf;
}
.btn{
  margin-top: 30px;
  margin-left: 20px;
  width: 140px;
  height: 50px;
}
img{
  height: 400px;
  width: 400px;
}
</style>
